import React from "react";
import { Link } from "react-router-dom";

import { ReactComponent as FaTrashAlt } from "../../icons/trash-bold.svg";
import { ReactComponent as FaClone } from "../../icons/copy.svg";
import { ReactComponent as FaEye } from "../../icons/eye-bold.svg";
import { ReactComponent as FaText } from "../../icons/text-bold.svg";
import { Button } from "../../components/forms/Form";

import { connect } from "react-redux";

class Overlay extends React.Component {
  _handleSubmit = () => {
    window.location.href = `/editor/${this.props.id}`;
  };
  render() {
    return (
      <div className="website-item-overlay">
        <nav>
          <ul>
            <li>
              <FaTrashAlt
                onClick={() => {
                  this.props.toggleDeletePopUp(this.props.store);
                }}
              />
            </li>
            <li>
              <FaText
                onClick={() => {
                  // this.props.setEditingStore(this.props.store);
                  this.props.toggleModifyPopUp(this.props.store);
                }}
              />
            </li>
            <li>
              <FaClone
                onClick={() => this.props.handleDuplicate(this.props.id)}
              />
            </li>
            <li>
              <Link to={`/preview/${this.props.id}`}>
                <FaEye />
              </Link>
            </li>
          </ul>
        </nav>
        <div className="website-item-button-container">
          <Button handleSubmit={this._handleSubmit} text={"Modifica"} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.data.user,
  authToken: state.user.data.authToken,
  loading: state.user.loading,
  error: state.user.error,
});

export default connect(mapStateToProps, {})(Overlay);
